import React from 'react'
import "./style.css"

const Header2 = () => {
  return (
    <div className='home-header'>
        <h2>
            Foresight Internships
        </h2>
        <h1>
            <span>
                </span> Blogs <span>
            </span>
        </h1>
        <p>
            A to Z about prefinal year CDC Internships<br/>
        </p>
    </div>
  )
}

export default Header2
